// extracted by mini-css-extract-plugin
export var about = "index-module--about--1zX4E";
export var content = "index-module--content--ZXwgT";
export var contentFlex = "index-module--contentFlex--1UDej";
export var image = "index-module--image--2THIp";
export var instagram = "index-module--instagram--3r1SH";
export var puppies = "index-module--puppies--1QX1n";
export var colorChange = "index-module--colorChange--1OycB";